/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Generic success response with message
 * @export
 * @interface SuccessMessageResponse
 */
export interface SuccessMessageResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SuccessMessageResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuccessMessageResponse
     */
    message: string;
}

/**
 * Check if a given object implements the SuccessMessageResponse interface.
 */
export function instanceOfSuccessMessageResponse(value: object): value is SuccessMessageResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function SuccessMessageResponseFromJSON(json: any): SuccessMessageResponse {
    return SuccessMessageResponseFromJSONTyped(json, false);
}

export function SuccessMessageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuccessMessageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function SuccessMessageResponseToJSON(json: any): SuccessMessageResponse {
    return SuccessMessageResponseToJSONTyped(json, false);
}

export function SuccessMessageResponseToJSONTyped(value?: SuccessMessageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

